export default {
    state: {
        snackBarShow: false,
        snackBarMessage: null,
        snackBarMessageRaw: null,
        snackBarColor: null,
        snackBarTimeout: null,
        breadcrumbs: [],
        contentReload: 0,
        langs: [
            {name: 'Русский', code: 'ru'},
            {name: 'English', code: 'en'}
        ],
        extraMobileMenu: null,
        utm: null
    },
    mutations: {
        setUtm(state, payload) {
            state.utm = payload;
        },
        setSnackBarError(state, payload) {
            state.snackBarShow = true;
            state.snackBarMessage = payload;
            state.snackBarColor = 'red';
            state.snackBarTimeout = 5000;
        },
        setSnackBarInfo(state, payload) {
            state.snackBarShow = true;
            state.snackBarMessage = payload;
            state.snackBarColor = 'info';
            state.snackBarTimeout = 5000;
        },
        setSnackBar(state, {msg, msgRaw, timeout, color}) {
            state.snackBarShow = true;
            state.snackBarMessage = msg ? msg : null;
            state.snackBarMessageRaw = msgRaw ? msgRaw : null;
            state.snackBarColor = color ? color : 'info';
            state.snackBarTimeout = timeout ? timeout : 5000;
        },
        clearSnackBar(state) {
            state.snackBarShow = false;
            state.snackBarMessage = null;
            state.snackBarMessageRaw = null;
            state.snackBarColor = null;
        },
        setBreadcrumbs(state, payload) {
            state.breadcrumbs = payload
        },
        contentReload(state) {
            state.contentReload++;
        },
        changeExtraMobileMenu(state, payload) {
            state.extraMobileMenu = payload;
        }
    },
    getters: {
        breadcrumbs(state) {
            return state.breadcrumbs;
        }
    },
    actions: {
        loadPackages() {
            return this.dispatch('sendRequest', {path: '/package'});
        },
    }
}